export default {
	updateUploadMedia(state, { key, ...rest }) {
		if (rest.err) {
			state.media = {
				...state.media,
				[key]: {
					err: rest.err
				}
			};
			return;
		}
		state.media = {
			...state.media,
			[key]: {
				...state.media[key],
				...rest
			}
		};
	},
	showAlert(state, payload) {
		state.alert.show = true;
		state.alert.text = payload.text;
	}
};
